// ES6 Imports
import Extent from "@arcgis/core/geometry/Extent.js";
import TileLayer from "@arcgis/core/layers/TileLayer.js";
import Basemap from "@arcgis/core/Basemap.js";
import WebMap from "@arcgis/core/WebMap.js";
import MapView from "@arcgis/core/views/MapView.js";
import MapImageLayer from "@arcgis/core/layers/MapImageLayer.js";
import { thumbnails } from "../util/thumbnails.js";

import WMTSLayer from "@arcgis/core/layers/WMTSLayer.js";
import VectorTileLayer from "@arcgis/core/layers/VectorTileLayer.js";

export default async function (conditionalMapOptions) {
  return new Promise((resolve, reject) => {
    try {
      let basemaps = [];

      Object.entries(conditionalMapOptions.baseMaps).forEach(entry => {
        try {
          let [key, value] = entry;
          let layers = [];
          value.layers.forEach((layer) => {
            switch(layer.type.toLowerCase()){
              case "wmts": {
                let layerToAdd = new WMTSLayer({
                  url: layer.url 
                });
                if (layer.opacity)
                {
                  layerToAdd.opacity = layer.opacity;
                }
                layers.push(layerToAdd); 
                break; 
              }
              case "vector": {
                let layerToAdd = new VectorTileLayer({
                  url: layer.url 
                });
                if (layer.opacity)
                  {
                    layerToAdd.opacity = layer.opacity;
                  }
                layers.push(layerToAdd); 
                break; 
              }
              case "image": {
                let layerToAdd = new MapImageLayer({
                  url: layer.url,
                  title: key
                });
                if (layer.opacity)
                  {
                    layerToAdd.opacity = layer.opacity;
                  }
                layers.push(layerToAdd);
                break; 
                break; 
              }
              case "tile": {
  
              }
              case null: {
    
              }
              default: {
                let layerToAdd = new TileLayer({
                  url: layer.url,
                  title: key
                });
                if (layer.opacity)
                  {
                    layerToAdd.opacity = layer.opacity;
                  }
                layers.push(layerToAdd);
                break; 
              }
            }
          })
        
          let basemap = new Basemap({
            baseLayers: layers,
            title: key,
            id: key,
          });
          if (value.thumbnail)
          {
            basemap.thumbnailUrl = value.thumbnail;
          }
  
          basemaps.push(basemap);

        }
        catch {
          window.alert("Error loading basemap " + entry[0]);
        }
      });

      let map = new WebMap({
        basemap: basemaps[0],
        layers: []
      });

      let view = new MapView({
        container: "viewDiv",
        map: map,
        padding: {
          top: 50,
          bottom: 0
        },
        ui: { components: [] },
        constraints: {maxScale: 371}
      });

      view.extent = new Extent({
        xmin: conditionalMapOptions.extent.xmin,
        ymin: conditionalMapOptions.extent.ymin,
        xmax: conditionalMapOptions.extent.xmax,
        ymax: conditionalMapOptions.extent.ymax,
        spatialReference: conditionalMapOptions.extent.spatialReference || {
          wkid: 3436
        }
      });

      map.basemaps = basemaps;

      // Function to clear selection
      const clear = () => {
        if (window.getSelection) {
          if (window.getSelection().empty) {  // Chrome
            window.getSelection().empty();
          } else if (window.getSelection().removeAllRanges) {  // Firefox
            window.getSelection().removeAllRanges();
          }
        } else if (document.selection) {  // IE?
          document.selection.empty();
        }
      };

      view.on("click", clear);
      view.on("drag", clear);
      if (window.location.href.includes("localhost"))
      {
        window.view = view;
        window.map = map;
      }
      resolve([map, view]);
    } catch (error) {
      reject(error);
    }
  });
}
